import React from 'react';
import radium from 'radium';
import './RadioSelection.scss';
import {ThemeContext} from '../theme/Theme.jsx';

interface RadioSelectionProps {
	name: string,
	value: string,
	radioGroupValue?: string,
	label: any,
	onChange: any,
	labelStyle?: any,
	disabled?: boolean
}

function RadioSelection(props: RadioSelectionProps) {
	const context = React.useContext(ThemeContext);

	const radioStyle = {
		color: context.themeManager.value('radio-button', 'color', 'fg-color-form-element'),
		selectedColor: context.themeManager.value('radio-button', 'selectedColor', 'fg-color-form-element'),
		hoverColor: context.themeManager.value('radio-button', 'hoverColor', 'border-color-form-element-focus'),
		accentColor: context.themeManager.value('radio-button', 'accentColor', 'border-color-form-element-focus'),
		backgroundColor: context.themeManager.value('radio-button', 'backgroundColor', 'bg-color-form-element'),
		borderColor: context.themeManager.value('radio-button', 'borderColor', 'border-color-form-element'),
		checkedBackgroundColor: context.themeManager.value('radio-button', 'checkedBackgroundColor', 'bg-color-form-element'),
		checkedDotColor: context.themeManager.value('radio-button', 'checkedDotColor', 'fg-color-form-element'),
		disabledColor: context.themeManager.value('radio-button', 'disabledColor', 'fg-color-text-disabled'),
		outlineColor: context.themeManager.value('radio-button', 'outlineColor', 'border-color-form-element-focus'),
	};

	const style: any = {
		selected: {
			color: radioStyle.selectedColor,
			fontWeight: 'bold',
		},
		default: {
			color: radioStyle.color,
			fontWeight: 'normal',
			":hover": {
				//color: radioStyle.hoverColor,
				cursor: "pointer",
			},
		},
		disabled: {
			color: radioStyle.disabledColor,
			":hover": {
				//color: radioStyle.disabledColor,
				cursor: "not-allowed",
			},
		},
		input: {
			accentColor: radioStyle.accentColor,
			backgroundColor: radioStyle.backgroundColor,
			borderColor: radioStyle.borderColor,
			'--radio-selection-background-color': radioStyle.backgroundColor,
			'--radio-selection-border-color': radioStyle.borderColor,
			'--radio-selection-checked-background-color': radioStyle.checkedBackgroundColor,
			'--radio-selection-checked-dot-color': radioStyle.checkedDotColor,
			'--radio-selection-disabled-color': radioStyle.disabledColor,
			'--radio-selection-outline-color': radioStyle.outlineColor,
		},
	};

	const {
		name,
		value,
		onChange,
		radioGroupValue,
		label,
		disabled,
		labelStyle
	} = props;

	const randomId = parseInt(String(Math.random() * 100000), 10);
	const labelStyleSelected:any = radioGroupValue === value && !disabled ? style.selected : {}
	const labelStyleDisabled:any = disabled ? style.disabled : {}
	const labelStyleCompl:any = {...labelStyleDisabled, ...style.default, ...labelStyle, ...labelStyleSelected}

	return (
		<div className="radio__selection" style={disabled ? style.disabled : null} key="radio">
			<input
				id={name + randomId}
				type="radio"
				name={name}
				value={value}
				checked={radioGroupValue === value && !disabled}
				onChange={onChange}
				disabled={disabled}
				className="radio__button"
				style={style.input}
			/>
			<label
				htmlFor={name + randomId}
				style={labelStyleCompl}
			>{label}</label>
		</div>
	);
}

const RadiumRadioSelection = radium(RadioSelection);

export default RadiumRadioSelection;
